<template>
  <div class="testPaperCenterSty page-breadcrumb clearfix">
    <div class="header-row">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item @click.native="toQuestionList">题库搜题</el-breadcrumb-item>
        <el-breadcrumb-item>题目详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary" size="small"  @click="toQuestionList">
        <i class="el-icon-back"></i> 返回题库
      </el-button>
    </div>

    <div class="contentSty">
      <!-- 左侧区域 -->
      <div class="one">
        <!-- 第一个区域：标签+题目ID+创建时间 -->
        <el-card class="left-card info-card">
          <div class="tag-area">
            <el-tag size="small">{{ formattedQuestionInfo.source }}</el-tag>
            <el-tag size="small" type="warning">{{ formattedQuestionInfo.typeTag }}</el-tag>
            <el-tag size="small" type="warning">
              难度:
              <span class="stars">{{ difficultyStars }}</span>
            </el-tag>
            <el-tag size="small" type="info">{{ formattedQuestionInfo.typeLabel }}</el-tag>
          </div>
          <div class="question-meta">
            <span>题目ID: {{ id }}</span>
            <span style="margin-left: 40px;">创建时间: {{ questionBody.createTime }}</span>
          </div>
        </el-card>

        <!-- 第二个区域：题目内容 -->
        <div class="question-bank-detail">
          <component
              :is="currentQuestionComponent"
              :subjectId="questionBody.itemOrder"
              :questionBody="questionBody"
              @changed="changed"
              @unchanged="unchanged"
          />
        </div>

        <!-- 第三个区域：按钮组 -->
        <el-card class="left-card button-card">
          <div class="button-group">
            <el-button type="primary" @click="submitAnswer">
              <i class="el-icon-check"></i> 提交答案
            </el-button>
            <el-button :type="showAnalysis ? 'info' : 'warning'" @click="toggleAnalysis">
              <i class="el-icon-view"></i> {{ showAnalysis ? '隐藏解析' : '显示解析' }}
            </el-button>
            <el-button :type="isCollected ? 'info' : 'warning'" @click="toggleCollect">
              <i :class="isCollected ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
              {{ isCollected ? '取消收藏' : '收藏' }}
            </el-button>
            <el-button type="danger" @click="cancelQuestion">
              <i class="el-icon-close"></i> 取消答题
            </el-button>
          </div>
        </el-card>

        <!-- 答案解析区域 -->
        <el-card ref="analysisCard" class="left-card analysis-card" v-if="showAnalysis">
          <div slot="header" class="card-header analysis-header">
            <i class="el-icon-info"></i>
            <span>答案解析</span>
          </div>
          <div class="card-body">
            <div class="correct-answer">
              <span class="label">正确答案:</span>
              <!-- 编程题使用 Monaco Editor 展示 -->
              <template v-if="isProgrammingQuestion">
                <div class="monaco-editor-wrapper">
                  <div class="editor-toolbar">
                    <div class="toolbar-left">
                      <span class="lang-tag">{{ currentLang }}</span>
                    </div>
                    <div class="toolbar-right">
                      <span class="toolbar-btn disabled">
                        <i class="el-icon-cpu"></i> AI写代码
                      </span>
                      <span class="toolbar-btn" @click="handleCopyAnswer">
                        <i class="el-icon-document-copy"></i> 复制
                      </span>
                      <span class="toolbar-btn run-btn disabled">
                        <i class="el-icon-video-play"></i> 运行
                      </span>
                    </div>
                  </div>
                  <div ref="answerEditorContainer" class="monaco-editor-container"></div>
                </div>
              </template>
              <!-- 非编程题直接显示答案 -->
              <span v-else class="answer-value">{{ formattedQuestionInfo.correct }}</span>
            </div>
            <div class="analysis-content">
              <div class="label">解析说明:</div>
              <div class="analysis-text" v-html="formattedQuestionInfo.analyze"></div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 右侧区域 -->
      <div class="two">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>相关属性</span>
          </div>
          <div class="question-info">
            <div class="info-item">
              <span class="info-label">作者:</span>
              <span class="info-value">匿名</span>
            </div>
            <div class="info-item">
              <span class="info-label">题型:</span>
              <span class="info-value">{{ formattedQuestionInfo.typeLabel }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">代码限制:</span>
              <span class="info-value">100 KB</span>
            </div>
            <div class="info-item">
              <span class="info-label">时间限制:</span>
              <span class="info-value">30 min</span>
            </div>
            <div class="info-item">
              <span class="info-label">内存限制:</span>
              <span class="info-value">64 MB</span>
            </div>
            <div class="info-item">
              <span class="info-label">发布时间:</span>
              <span class="info-value">{{ questionBody.createTime }}</span>
            </div>
          </div>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px">
          <div id="myChart2" style="width:100%;height: 300px;padding-bottom: 10px"></div>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;text-align: center">
          <div slot="header" class="clearfix">
            <span>讨论区</span>
          </div>
          暂未开放
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import radioSubject from "@/components/radioSubject.vue"
import checkSubject from "@/components/checkSubject.vue"
import blankSubject from "@/components/blankSubject.vue"
import shortAnswerSubject from "@/components/shortAnswerSubject.vue"
import programmingSubject from "@/components/programmingSubject.vue"
import programmingSubjectMore from "@/components/programmingSubjectMore.vue"
import * as monaco from 'monaco-editor'
import {
  completeQuestionSubmission,
  hasQuestionAnswer,
  loadQuestionData
} from '@/utils/questionAnswer.mjs'
import {
  getQuestionDetail,
  getQuestionAnalysis,
  submitQuestionAnswer
} from "@/api/index.js"
import * as echarts from "echarts";
// 引入饼状图组件
require('echarts/lib/chart/pie')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

// 常量配置
// 语言映射
const LANG_MAP = {
  'Python': 'python',
  'C': 'cpp',
  'Cpp': 'cpp',
  'Java': 'java',
  'JavaScript': 'javascript',
  'Scratch': 'scratch'
}

const QUESTION_TYPES = {
  SINGLE_CHOICE: 0,
  TRUE_FALSE: 1,
  MULTIPLE_CHOICE: 2,
  SHORT_ANSWER: 3,
  PROGRAMMING: 4,
  FILL_BLANK: 5
}

const QUESTION_TYPE_LABELS = {
  [QUESTION_TYPES.SINGLE_CHOICE]: "单选题",
  [QUESTION_TYPES.TRUE_FALSE]: "判断题",
  [QUESTION_TYPES.MULTIPLE_CHOICE]: "多选题",
  [QUESTION_TYPES.SHORT_ANSWER]: "简答题",
  [QUESTION_TYPES.PROGRAMMING]: "编程题",
  [QUESTION_TYPES.FILL_BLANK]: "填空题"
}

const COLORS = {
  PRIMARY: '#409eff',
  WARNING: '#f5a623',
  SUCCESS: '#52c41a',
  INFO: '#909399',
  TEXT_SECONDARY: '#666',
  TEXT_LIGHT: '#999',
  BORDER_LIGHT: '#eee',
  BACKGROUND_LIGHT: '#f8f9fa'
}

export default {
  filters: {
    formatQuestionType(type) {
      return QUESTION_TYPE_LABELS[type] || '未知题型'
    },
    formatQuestionTypeTag(langCode) {
      const langTagMap = {
        'Scratch': 'Scratch',
        'C': 'C/C++',
        'Python': 'Python',
        'ROBOT': '机器人技术'
      }
      return langTagMap[langCode] || 'Scratch'
    }
  },
  props: {
    questionDetail: {
      type: Object,
      default: () => ({})
    },
    subjectId: {
      type: Number,
      default: 1
    }
  },
  components: {
    blankSubject,
    radioSubject,
    checkSubject,
    shortAnswerSubject,
    programmingSubject,
    programmingSubjectMore
  },
  computed: {
    currentQuestionComponent() {
      const typeMap = {
        [QUESTION_TYPES.SINGLE_CHOICE]: 'radioSubject',
        [QUESTION_TYPES.TRUE_FALSE]: 'radioSubject',
        [QUESTION_TYPES.MULTIPLE_CHOICE]: 'checkSubject',
        [QUESTION_TYPES.SHORT_ANSWER]: 'shortAnswerSubject',
        [QUESTION_TYPES.PROGRAMMING]: 'programmingSubject',
        [QUESTION_TYPES.FILL_BLANK]: 'blankSubject'
      }
      return typeMap[this.questionBody.questionType] || 'radioSubject'
    },

    // 计算难度星级
    difficultyStars() {
      const level = this.questionBody.difficult || 3;
      return '★'.repeat(Math.min(level, 5)) + '☆'.repeat(Math.max(0, 5 - level));
    },

    // 计算是否可以提交答案
    canSubmitAnswer() {
      return hasQuestionAnswer(this.answerRequest)
    },

    // 格式化的题目信息
    formattedQuestionInfo() {
      return {
        source: this.questionBody.matchCode || 'NOC',
        type: this.questionBody.questionType,
        typeLabel: this.$options.filters.formatQuestionType(this.questionBody.questionType),
        typeTag: this.$options.filters.formatQuestionTypeTag(this.questionBody.langCode),
        createTime: this.questionBody.createTime,
        correct: this.questionBody.correct || 'B',
        analyze: this.questionBody.analyze || '暂无解析'
      };
    },

    // 判断是否为编程题
    isProgrammingQuestion() {
      return this.questionBody.questionType === QUESTION_TYPES.PROGRAMMING;
    },

    // 正确答案代码（用于编程题）
    correctAnswerCode() {
      return this.questionBody.correct || '';
    },

    // 当前语言显示
    currentLang() {
      return LANG_MAP[this.questionBody.langCode] || 'python';
    },

    // Monaco Editor 语言映射
    monacoLang() {
      return LANG_MAP[this.questionBody.langCode] || 'python';
    }
  },
  data() {
    return {
      id: null,
      value1: 4.5,
      questionReadVM: {},
      answerRequest: {},
      questionBody: {},
      dialogVisible: false,
      answer: null,
      answerArray: [],
      answerText: '',
      showAnalysis: false,
      isCollected: true,
      answerEditor: null, // Monaco Editor 实例
    }
  },
  async mounted() {
    try {
      this.id = this.$route.query.id || this.subjectId;
      if (!this.id) {
        this.$message.error('题目ID不存在');
        return;
      }

      const res = await loadQuestionData(this.id, getQuestionDetail, getQuestionAnalysis);
      if (res.code === "0000") {
        this.questionBody = res.data;
      } else {
        this.$message.error(res.message || '获取题目详情失败');
      }
    } catch (error) {
      console.error('获取题目详情失败:', error);
      this.$message.error('获取题目详情失败，请重试');
    } finally {
      this.loading = false;
    }

    // 延迟初始化图表，确保DOM已渲染
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    //提交答案
    submitAnswer() {
      if (!this.canSubmitAnswer) {
        this.$message.error("请先填写答案后再提交！")
        return
      }

      const param = {
        questionId: this.id,
        content: this.answer,
        contentArray: this.answerArray,
        userAnswerFileId: this.answerRequest.userAnswerFileId || null
      }
      submitQuestionAnswer(param).then(res => {
        if (res.code === "0000") {
          completeQuestionSubmission(this, res.data)
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    changed(item) {
      this.answerRequest = item || {}
      this.answer = this.answerRequest.content == null ? null : this.answerRequest.content
      this.answerArray = Array.isArray(this.answerRequest.contentArray)
          ? this.answerRequest.contentArray
          : []
      // if (this.isAnswer.length == 0) {
      //     this.isAnswer.push(item)
      // } else {
      //     let flag = 0
      //     // console.log(this.isAnswer)
      //     this.isAnswer.forEach((item1) => {
      //         if (item1.id == item.id) {
      //             flag = 1
      //             item1.content = item.content
      //             item1.contentArray = item.contentArray
      //         } else {
      //         }
      //     })
      //     if (flag == 0) {
      //         this.isAnswer.push(item)
      //     }
      // }
    },
    unchanged(item) {
      this.answerRequest = {}
      this.answer = null
      this.answerArray = []
    },
    toQuestionList() {
      this.$router.go(-1);
      window.close()
    },
    toggleAnalysis() {
      this.showAnalysis = !this.showAnalysis;
    },

    toggleCollect() {
      this.isCollected = !this.isCollected;
      const message = this.isCollected ? '已收藏' : '已取消收藏';
      const type = this.isCollected ? 'success' : 'info';
      this.$message({
        message,
        type,
        duration: 2000
      });
    },
    // 取消答题并回到题库
    cancelQuestion() {
      this.$confirm('确定要取消答题并回到题库？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          path: '/questionBank'
        });
      }).catch(() => {
        // 用户取消
      });
    },
    // 初始化参考答案 Monaco Editor
    initAnswerEditor() {
      const container = this.$refs.answerEditorContainer;
      if (!container) return;

      // 创建参考答案 Monaco Editor 实例（只读）
      this.answerEditor = monaco.editor.create(container, {
        value: this.correctAnswerCode || '',
        language: this.monacoLang,
        theme: 'vs-dark',
        fontSize: 16,
        lineNumbers: 'on',
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        automaticLayout: true,
        tabSize: 4,
        wordWrap: 'on',
        folding: true,
        lineHeight: 24,
        readOnly: true,
        padding: { top: 10, bottom: 10 },
        scrollbar: {
          vertical: 'auto',
          horizontal: 'auto',
          verticalScrollbarSize: 10,
          horizontalScrollbarSize: 10,
          alwaysConsumeMouseWheel: false
        }
      });

      // 初始化高度
      this.updateEditorHeight(this.answerEditor, container);
    },

    // 根据代码行数动态调整编辑器高度
    updateEditorHeight(editor, container) {
      const lineHeight = 24;
      const padding = 20;
      const minHeight = 350;
      const lineCount = editor.getModel().getLineCount();
      const contentHeight = lineCount * lineHeight + padding;
      const newHeight = Math.max(contentHeight, minHeight);
      container.style.height = newHeight + 'px';
      editor.layout();
    },

    // 复制参考答案
    handleCopyAnswer() {
      const code = this.answerEditor ? this.answerEditor.getValue() : this.correctAnswerCode;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(() => {
          this.$message.success('参考答案已复制到剪贴板');
        }).catch(() => {
          this.$message.error('复制失败');
        });
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('参考答案已复制到剪贴板');
      }
    },

    initChart() {
      const chartElement = document.getElementById('myChart2');
      if (!chartElement) {
        console.warn('图表容器不存在');
        return;
      }

      try {
        const myChart = echarts.init(chartElement);

        // 图表配置
        const chartOption = {
          title: {
            text: '分析报告',
            subtext: '暂未开放',
            x: 'center',
            textStyle: {
              fontSize: 16,
              fontWeight: 'normal'
            },
            subtextStyle: {
              fontSize: 12,
              color: '#999'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            bottom: 'bottom',
            data: ['提交数', '正确率', '平均耗时'],
            textStyle: {
              fontSize: 12
            }
          },
          series: [{
            name: '题目统计',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
              {value: 1000, name: '提交数'},
              {value: 500, name: '正确率'},
              {value: 500, name: '平均耗时'}
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              show: true,
              formatter: '{b}: {c}'
            }
          }],
          color: ['#409eff', '#67c23a', '#f56c6c']
        };

        myChart.setOption(chartOption);

        // 监听窗口resize事件
        window.addEventListener('resize', () => {
          myChart.resize();
        });

      } catch (error) {
        console.error('图表初始化失败:', error);
      }
    }
  },
  watch: {
    // 监听 showAnalysis 变化，当显示解析时初始化编辑器
    showAnalysis(newVal) {
      if (newVal && this.isProgrammingQuestion) {
        this.$nextTick(() => {
          this.initAnswerEditor();
        });
      }
    }
  },
  beforeDestroy() {
    // 销毁 Monaco Editor 实例
    if (this.answerEditor) {
      this.answerEditor.dispose();
      this.answerEditor = null;
    }
  }

}
</script>

<style lang="scss" scoped>
// CSS 变量定义
.testPaperCenterSty {
  --primary-color: #409eff;
  --warning-color: #f5a623;
  --success-color: #52c41a;
  --info-color: #909399;
  --text-secondary: #666;
  --text-light: #999;
  --border-light: #eee;
  --background-light: #f8f9fa;
  --shadow-color: rgba(0, 0, 0, 0.1);
  --border-radius: 8px;
  --transition: all 0.3s ease;
}

/* 清除浮动 */
.clearfix::before,
.clearfix::after {
  content: "";
  display: table;
}

.clearfix::after {
  clear: both;
}

.clearfix {
  *zoom: 1;
}

.page-breadcrumb {
  margin: 15px 0;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/* 页头行：面包屑 + 返回按钮 */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.testPaperCenterSty {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 50px;
  min-height: 600px;

  text-align: left;
  position: relative;
  padding: 15px 20px;

  // 响应式设计
  @media (max-width: 768px) {
    padding: 0 15px;
    margin-top: 15px;
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
}

.contentSty {
  padding-bottom: 30px;
  margin-top: 20px;
  display: flex;
  gap: 20px;
  align-items: flex-start;

  // 响应式布局
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 15px;
  }
}

/* 左侧区域 */
.one {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 右侧区域 */
.two {
  width: 320px;
  flex-shrink: 0;

  // 响应式设计
  @media (max-width: 1024px) {
    width: 100%;
  }
}

/* 左侧卡片通用样式 */
.left-card {
  border-radius: var(--border-radius);
  box-shadow: 0 2px 12px var(--shadow-color);
  transition: var(--transition);
  border: 1px solid var(--border-light);

  &:hover {
    box-shadow: 0 4px 20px var(--shadow-color);
  }

  :deep(.el-card__header) {
    padding: 0;
    border-bottom: none;
  }

  :deep(.el-card__body) {
    padding: 20px;
  }
}

/* 信息卡片（标签+ID+时间） */
.info-card {
  :deep(.el-card__body) {
    padding: 16px 20px;
  }
}

/* 内容卡片 */
.content-card {
  border: 2px solid var(--warning-color);

  .content-header {
    background: var(--warning-color);
    color: #fff;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    border-radius: 6px 6px 0 0;

    i {
      margin-right: 8px;
      font-size: 18px;
    }
  }

  .card-body {
    background: linear-gradient(135deg, #fffbf0 0%, #fefefe 100%);
    padding: 20px;
  }
}

/* 按钮卡片 */
.button-card {
  :deep(.el-card__body) {
    padding: 16px 20px;
  }
}

/* 解析卡片 */
.analysis-card {
  border: 2px solid var(--primary-color);

  .analysis-header {
    background: var(--primary-color);
    color: #fff;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    border-radius: 6px 6px 0 0;

    i {
      margin-right: 8px;
      font-size: 18px;
    }
  }

  .card-body {
    background: linear-gradient(135deg, #f0f7ff 0%, #fefefe 100%);
    padding: 20px;
  }
}

/* 标签区域 */
.tag-area {
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .el-tag {
    border-radius: 4px;
    font-weight: 500;
    transition: var(--transition);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px var(--shadow-color);
    }
  }

  .stars {
    color: var(--warning-color);
    font-size: 14px;
  }
}

/* 题目元信息 */
.question-meta {
  color: var(--text-light);
  font-size: 14px;
  display: flex;
  align-items: center;

  // 响应式设计
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}



/* 答案输入区 */
.answer-input-area {
  margin-bottom: 20px;

  :deep(.el-textarea__inner) {
    border: 1px solid #ddd;
    border-radius: 4px;
  }
}

/* 题目信息样式 */
.question-info {
  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid var(--border-light);

    &:last-child {
      border-bottom: none;
    }

    .info-label {
      font-weight: 500;
      color: var(--text-secondary);
      min-width: 80px;
    }

    .info-value {
      color: #333;
      font-weight: 500;
    }
  }
}

/* 按钮组 */
.button-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  .el-button {
    border-radius: 6px;
    padding: 12px 24px;
    font-weight: 500;
    transition: var(--transition);
    min-width: 120px;

    i {
      margin-right: 6px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px var(--shadow-color);
    }
  }

  .el-button--primary {
    background: var(--primary-color);
    border-color: var(--primary-color);

    &:hover {
      background: darken(#409eff, 10%);
      border-color: darken(#409eff, 10%);
    }
  }

  .el-button--warning {
    background: var(--warning-color);
    border-color: var(--warning-color);
    color: #fff;

    &:hover {
      background: darken(#f5a623, 10%);
      border-color: darken(#f5a623, 10%);
    }
  }

  .el-button--info {
    background: var(--info-color);
    border-color: var(--info-color);
    color: #fff;

    &:hover {
      background: darken(#909399, 10%);
      border-color: darken(#909399, 10%);
    }
  }
}

/* 答案解析 */
.correct-answer {
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
  border-left: 4px solid var(--primary-color);
  border-radius: 6px;
  transition: var(--transition);

  &:hover {
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }

  .label {
    color: var(--text-secondary);
    font-weight: 500;
    display: block;
    margin-bottom: 12px;
  }

  .answer-value {
    color: var(--success-color);
    font-weight: bold;
    margin-left: 12px;
    font-size: 16px;
  }

  /* Monaco Editor 工具栏样式 */
  .monaco-editor-wrapper {
    margin-top: 12px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  }

  .editor-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    background: linear-gradient(135deg, #2d2d2d 0%, #1e1e1e 100%);
    border-bottom: 1px solid #3d3d3d;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
  }

  .lang-tag {
    padding: 2px 10px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    color: #e0e0e0;
    font-family: 'Consolas', 'Monaco', monospace;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .toolbar-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    font-size: 12px;
    color: #b0b0b0;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease;

    i {
      font-size: 13px;
    }

    &:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .toolbar-btn.run-btn {
    color: #67c23a;

    &:hover {
      background: rgba(103, 194, 58, 0.2);
    }

    &.disabled {
      color: #555;
    }
  }

  .toolbar-btn.disabled {
    color: #555;
    cursor: not-allowed;

    &:hover {
      color: #555;
      background: transparent;
    }
  }

  .monaco-editor-container {
    height: 350px;
    min-height: 350px;
    width: 100%;
    transition: height 0.2s ease;
  }

  /* Monaco Editor 整体圆角 */
  ::v-deep .monaco-editor {
    border-radius: 0 0 8px 8px;
  }

  ::v-deep .monaco-editor .overflow-guard {
    border-radius: 0 0 8px 8px;
  }
}

.analysis-content {
  .label {
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
    font-size: 16px;
  }

  .analysis-text {
    line-height: 1.8;
    color: var(--text-secondary);
    text-align: justify;
    background: rgba(255, 255, 255, 0.8);
    padding: 16px;
    border-radius: 6px;
    border: 1px solid var(--border-light);
  }
}

/* 右侧卡片样式 */
.box-card {
  text-align: left;
  border-radius: var(--border-radius);
  box-shadow: 0 2px 12px var(--shadow-color);
  transition: var(--transition);
  border: 1px solid var(--border-light);

  &:hover {
    box-shadow: 0 4px 20px var(--shadow-color);
  }

  .el-card__header {
    border-bottom: 1px solid var(--border-light);
    font-weight: 600;
  }

  .el-card__body {
    padding: 20px;
  }
}
</style>
